import { SortOrder } from '../../enums';

export class PaginationParams {
  page?: number;
  perPage?: number;
  orderBy?: SortOrder;
}
